import $ from "jquery";
window.$ = window.jQuery = $;
Object.defineProperty(window, "$", { value: $, writable: false });
Object.defineProperty(window, "jQuery", { value: $, writable: false });
require("owl.carousel/dist/owl.carousel");